import styled from '@emotion/styled'
import { theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import { uniqBy } from 'lodash'
import React, { memo } from 'react'

import { Filters } from './Filters'
import { Props as RoomProps, Room } from './Room'

export interface Props {
  filters?: string[]
  rooms: RoomProps[]
}

export const RoomsList = memo(function RoomsList({ filters, rooms }: Props) {
  if (!rooms) {
    return null
  }

  return (
    <Container>
      {filters ? <Filters rooms={filters} /> : null}

      <Wrapper>
        {uniqBy(rooms, 'title').map((item, index) => (
          <Room key={index} index={index + 1} {...item} />
        ))}
      </Wrapper>
    </Container>
  )
})

const Container = styled.section`
  margin-top: 6rem;

  @media (max-width: 1199px) {
    border-top: 0.0625rem solid ${rgba(theme.colors.variants.neutralDark1, 0.1)};
    margin-top: 3rem;
  }
`

const Wrapper = styled.div``
